import { render, staticRenderFns } from "./DeliveryPaymentDrawerMethodsList.vue?vue&type=template&id=e499715a"
import script from "./DeliveryPaymentDrawerMethodsList.vue?vue&type=script&lang=js"
export * from "./DeliveryPaymentDrawerMethodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports